import styled from 'styled-components'

type Props = {
	width: string
}

/** Placeholder fill element. Primarily available for overriding styling inside specific components. */
export const Fill = styled.span<Props>`
	display: inline-block;
	background-color: currentColor;
	height: 0.8em;
	border-radius: 0.4em;
	opacity: 0.2;
	width: ${({ width }) => width};
	vertical-align: baseline;
`
